export enum RTU_STATUS {
  // 空闲状态
  idle = 1,
  // 充电状态一一直充充电
  charging_1,
  // 充电状-恒压充电
  charging_2,
  // 充电状态——涓流充电
  charging_3,
  // 充电状态——MPPT 充电
  charging_4,
  // 充电状态——充电暂停
  charging_5,
  // 放电状态一一灯亮
  discharge_1,
  // 放电状态一一灯灭
  discharge_2,
  // 手动开灯状态一一灯亮
  manual_light,
  // 放电结束状态
  discharge_end,
  // 输出过功率保护
  over_power,
  // 蓄电池欠压保护
  under_voltage,
  // 输出硬件短路保护
  short_circuit,
  // 超温保护
  over_temperature,
  // 输出过压保护
  over_voltage,
  // 输入电压异常保护
  input_voltage,
  // 输入充电过流保护
  input_over_current,
  // 型号错或等待学习
  model_error,
}

export const RTU_STATUS_MAP = {
  [RTU_STATUS.idle]: '空闲状态',
  [RTU_STATUS.charging_1]: '充电状态一一直充充电',
  [RTU_STATUS.charging_2]: '充电状态一恒压充电',
  [RTU_STATUS.charging_3]: '充电状态—涓流充电',
  [RTU_STATUS.charging_4]: '充电状态—MPPT 充电',
  [RTU_STATUS.charging_5]: '充电状态一充电暂停',
  [RTU_STATUS.discharge_1]: '放电状态一灯亮',
  [RTU_STATUS.discharge_2]: '放电状态一灯灭',
  [RTU_STATUS.manual_light]: '手动开灯状态一灯亮',
  [RTU_STATUS.discharge_end]: '放电结束状态',
  [RTU_STATUS.over_power]: '输出过功率保护',
  [RTU_STATUS.under_voltage]: '蓄电池欠压保护',
  [RTU_STATUS.short_circuit]: '输出硬件短路保护',
  [RTU_STATUS.over_temperature]: '超温保护',
  [RTU_STATUS.over_voltage]: '输出过压保护',
  [RTU_STATUS.input_voltage]: '输入电压异常保护',
  [RTU_STATUS.input_over_current]: '输入充电过流保护',
  [RTU_STATUS.model_error]: '型号错或等待学习',
};
